var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboPhotoPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5101 7.00024C13.3386 7.00024 14.0101 6.32867 14.0101 5.50024C14.0101 4.67182 13.3386 4.00024 12.5101 4.00024C11.6817 4.00024 11.0101 4.67182 11.0101 5.50024C11.0101 6.32867 11.6817 7.00024 12.5101 7.00024Z",
    fill: "fillColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0101318 0.500244V17.5002C0.0101318 17.7802 0.230132 18.0002 0.510132 18.0002H19.5101C19.7901 18.0002 20.0101 17.7802 20.0101 17.5002V0.500244C20.0101 0.220244 19.7901 0.000244141 19.5101 0.000244141H0.510132C0.230132 0.000244141 0.0101318 0.220244 0.0101318 0.500244ZM2.01013 2.00024H18.0101V8.58024L16.3601 6.94024C16.1601 6.75024 15.8501 6.75024 15.6501 6.94024L12.0001 10.5902L6.35013 4.94024C6.15013 4.74024 5.84013 4.74024 5.64013 4.94024L1.99013 8.58024V2.00024H2.01013ZM18.0101 16.0002H2.01013V11.4202L6.01013 7.41024L11.6601 13.0602C11.8601 13.2602 12.1701 13.2602 12.3701 13.0602L16.0201 9.41024L18.0201 11.4202V16.0002H18.0101Z",
    fill: "fillColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboPhotoPicture);
export default __webpack_public_path__ + "static/media/FBOPhotoPicture.32a3b83dacaffdbca501a98ff3cdeec8.svg";
export { ForwardRef as ReactComponent };